import { render, staticRenderFns } from "./tblmain.vue?vue&type=template&id=0cf4cb08"
import script from "./tblmain.vue?vue&type=script&lang=js"
export * from "./tblmain.vue?vue&type=script&lang=js"
import style0 from "./tblmain.vue?vue&type=style&index=0&id=0cf4cb08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports